import _ from "lodash";
import moment from 'moment';
import 'moment/locale/es';
import locale from 'antd/es/date-picker/locale/es_ES';
import {

  GET_SPECIALITIES,
  SET_SELECTED_SPECIALITY,
  SET_SIDEBAR_RIGHT,
  CREATE_SPECIALTY,
  EDIT_SPECIALTY,
  DELETE_SPECIALTY,

  // ---SUBSPECIALTIES---//
  GET_SUB_SPECIALITIES,
  SET_SELECTED_SUB_SPECIALITIES,
  CREATE_SUB_SPECIALTY,
  EDIT_SUB_SPECIALTY,
  DELETE_SUB_SPECIALTY,

  // ---Clinical case quiz---//
  RESET_CLINICAL_CASE,
  DELETE_CLINICAL_CASE,
  EDIT_CLINICAL_CASE,
  SET_SELECTED_CLINICAL_CASE,
  GET_CLINICAL_CASES,
  SET_FILTERS_CLINICAL_CASES,
  RESET_FILTERS,
  SET_STATUS,

  //QUESTIONS
  NEW_CLINICAL_CASE,
  EDIT_CLINICAL_TEXT,
  STATUS_QUESTION_LANGUAGE,
  ADD_QUESTION,
  EDIT_QUESTION,
  DELETE_QUESTION,
  EDIT_QUESTION_JUSTIFICATION,
  ADD_ANSWER,
  EDIT_ANSWER,
  DELETE_ANSWER,
  CORRECT_ANSWER,
  ADD_IMAGES,
  DELETE_IMAGES,
  ADD_REFERENCE,
  EDIT_REFERENCE,
  DELETE_REFERENCE,
  ADD_COMMENT,
  EDIT_COMMENT,
  DELETE_COMMENT,
} from '../../constants/ActionTypes';
import { fetchAsync, uploadData3 } from '../../util/fetchers';
import {
  urlSpecialities, subSpecialities,
  urlClinicalCases, urlTestImage, uploadImg
} from '../../util/globals';

import { caseTemplate, answerTemplate, questionTemplate } from '../../constants/constants';

const dateFormat = 'DD/MM/YYYY';

export default (state, dispatch) => ({

  // ==================================================//
  // ======================SPECIALITIES================//
  // ==================================================//
  getSpecialities: () => {
    return fetchAsync(urlSpecialities, "", "GET", "")
      .then((payload) => {
        dispatch({ type: GET_SPECIALITIES, payload });
        return payload;
      })
  },

  createSpecialty: (specialtyData) => {
    return fetchAsync(urlSpecialities, JSON.stringify(specialtyData), "POST", "")
      .then((payload) => {
        dispatch({ type: CREATE_SPECIALTY, payload });
        return payload;
      })
  },

  editSpecialty: (specialtyData, _idSpecialty) => {
    return fetchAsync(urlSpecialities + `/${_idSpecialty}`, JSON.stringify(specialtyData), "PUT", "")
      .then((payload) => {
        dispatch({ type: EDIT_SPECIALTY, payload });
        return payload;
      })
  },

  deleteSpecialty: (_idSpecialty) => {
    return fetchAsync(urlSpecialities + `/${_idSpecialty}`, "", "DELETE", "")
      .then((payload) => {
        dispatch({ type: DELETE_SPECIALTY, payload });
        return payload;
      })
  },

  setSelectedSpeciality: (specialityData) => {
    dispatch({ type: SET_SELECTED_SPECIALITY, payload: { success: true, specialityData } });
  },


  // ==================================================//
  // ======================SUB SPECIALITIES============//
  // ==================================================//
  // getSubSpecialities: () => {
  //   return fetchAsync(subSpecialities, "", "GET", "")
  //     .then((payload) => {
  //       dispatch({ type: GET_SUB_SPECIALITIES, payload });
  //       return payload;
  //     })
  // },

  setIsSidebarRightOpen: () => {
    dispatch({ type: SET_SIDEBAR_RIGHT, payload: { success: true } });
  },

  setSelectedSubSpeciality: (subSpecialityData) => {
    dispatch({ type: SET_SELECTED_SUB_SPECIALITIES, payload: { success: true, subSpecialityData } });
  },

  createSubSpecialty: (subSpecialtyData) => {
    return fetchAsync(subSpecialities, JSON.stringify(subSpecialtyData), "POST", "")
      .then((payload) => {
        dispatch({ type: CREATE_SUB_SPECIALTY, payload });
        return payload;
      })
  },

  editSubSpecialty: (subSpecialtyData, _idSubspecialty) => {
    return fetchAsync(subSpecialities + `/${_idSubspecialty}`, JSON.stringify(subSpecialtyData), "PUT", "")
      .then((payload) => {
        dispatch({ type: EDIT_SUB_SPECIALTY, payload });
        return payload;
      })
  },

  deleteSubspecialty: (_idSubspecialty) => {
    return fetchAsync(subSpecialities + `/${_idSubspecialty}`, "", "DELETE", "")
      .then((payload) => {
        dispatch({ type: DELETE_SUB_SPECIALTY, payload });
        return payload;
      })
  },

  // ==================================================//
  // ===================CLINICAL CASESES===============//
  // ==================================================//

  getClinicalCases: (subSpecialtyId) => {
    return fetchAsync(urlClinicalCases + `/?idSubSpeciality=${subSpecialtyId}`, "", "GET", "")
      .then((payload) => {
        dispatch({ type: GET_CLINICAL_CASES, payload });
        return payload;
      })
  },

  filtersClinicalCases: async (filters) => {
    const { user, datesRange, status } = filters
    const cloneClincalCases = _.cloneDeep(state.clinicalCases)

    let resultAll = []

    const byUser = () => {
      // console.log("por_Usuario")
      let casesUserArray = user ? cloneClincalCases.filter((dataCase) => dataCase.createdBy?._id === user._id) : []
      return casesUserArray
    };

    const byDate = () => {
      if (datesRange) {
        // console.log("por_fecha")
        let start = new Date(datesRange.startDate.split('T')[0])
        let end = new Date(datesRange.endDate.split('T')[0])

        let casesDateRange = resultAll.length > 0 ?
          resultAll.filter((caseData) => {
            // console.log("entro al allArray")
            let created = new Date(caseData.dateCreated.split('T')[0])

            if (created >= start && created <= end) {
              return caseData
            }
          }) :
          cloneClincalCases.filter((caseData) => {
            // console.log("clone array")
            let created = new Date(caseData.dateCreated.split('T')[0])
            if (created >= start && created <= end) {
              return caseData
            }
          })
        return casesDateRange
      } else {
        return resultAll
      }
    };

    const byInEnglish = () => {
      // console.log("por_Igles")
      // console.log(resultAll)
      let englishResult = resultAll.length > 0 ?
        resultAll.filter((caseData) => {
          if (caseData.inEnglish) {
            return caseData
          }
        }) :
        cloneClincalCases.filter((caseData) => {
          if (caseData.inEnglish) {
            return caseData
          }
        })
      return englishResult
    }

    const byNeedReview = () => {
      // console.log("por_Necesita_revision")
      // console.log(resultAll)
      let needReviewResult = resultAll.length > 0 ?
        resultAll.filter((caseData) => {
          if (caseData.needReview) {
            return caseData
          }
        }) :
        cloneClincalCases.filter((caseData) => {
          if (caseData.needReview) {
            return caseData
          }
        })
      return needReviewResult
    }

    const byIsNotValidated = () => {
      // console.log("por_no_Validado")
      // console.log(resultAll)
      let isNotValidatedResult = resultAll.length > 0 ?
        resultAll.filter((caseData) => {
          if (!caseData.isValidated) {
            return caseData
          }
        }) :
        cloneClincalCases.filter((caseData) => {
          if (!caseData.isValidated) {
            return caseData
          }
        })
      return isNotValidatedResult
    }

    resultAll = await byUser()
    resultAll = await byDate()
    if (status) {
      let inEnglish = status.includes("Ingles");
      let needReview = status.includes("Necesita revisión");
      let isNotValidated = status.includes("No esta validado");
      if (inEnglish) resultAll = await byInEnglish()
      if (needReview) resultAll = await byNeedReview()
      if (isNotValidated) resultAll = await byIsNotValidated()
    }

    // console.log("ver_resultado")
    // console.log(resultAll)
    // console.log("ver_resultado")

    const filtersRes = {
      filters,
      resultAll
    }

    dispatch({ type: SET_FILTERS_CLINICAL_CASES, payload: { success: true, filtersRes } });
    return resultAll
  },

  resetFilters: () => {
    dispatch({ type: RESET_FILTERS, payload: { success: true } });
  },

  setSelectedClinicalCase: (clinicalCaseData) => {
    dispatch({ type: SET_SELECTED_CLINICAL_CASE, payload: { success: true, clinicalCaseData } });
  },


  // ------------------CLINICAL CASE FUNCTIONS-------------//

  resetClinicalCase: () => {
    dispatch({ type: RESET_CLINICAL_CASE, payload: { success: true } });
  },

  newClinicalCase: () => {
    const newCase = _.cloneDeep(caseTemplate)
    newCase.idQuestions.push(questionTemplate)
    console.log("VEE_nuevooo")
    console.log(caseTemplate)
    console.log(newCase)
    console.log("VEE_nuevooo")
    dispatch({ type: NEW_CLINICAL_CASE, payload: { success: true, newCase } });
  },

  deleteClinicalCase: (idClinicalCase) => {
    return fetchAsync(`${urlClinicalCases}/${idClinicalCase}`, "", "DELETE", "")
      .then((payload) => {
        dispatch({ type: DELETE_CLINICAL_CASE, payload });
        return payload;
      })
  },

  saveNewClinicalCase: (newClinicalCase) => {
    return fetchAsync(urlClinicalCases, JSON.stringify(newClinicalCase), "POST", "")
      .then((payload) => {
        console.log("ON_save_new_clnicalCase")
        console.log(payload)
        console.log("ON_save_new_clnicalCase")
        payload.isNew = true
        dispatch({ type: EDIT_CLINICAL_CASE, payload });
        return payload;
      })
  },

  editClinicalCase: (copyClinicalCase) => {

    delete copyClinicalCase._id
    delete copyClinicalCase.idEmployee
    delete copyClinicalCase.createdBy
    delete copyClinicalCase.dateCreated
    delete copyClinicalCase.idSpeciality
    delete copyClinicalCase.idSubSpeciality
    delete copyClinicalCase.lastEdition
    //TODO = this two inEnglish and needReview need to be implement
    // delete copyClinicalCase.inEnglish
    // delete copyClinicalCase.needReview


    console.log("Final_copyClinicalCase")
    console.log(copyClinicalCase)
    console.log("Final_copyClinicalCase")
    return fetchAsync(urlClinicalCases + `/${state.selectedClinicalCase._id}`, JSON.stringify(copyClinicalCase), "PUT", "")
      .then((payload) => {
        dispatch({ type: EDIT_CLINICAL_CASE, payload });
        return payload;
      })
  },

  setStatus: (objStatus) => {
    dispatch({ type: SET_STATUS, payload: { success: true, objStatus } });
  },

  editClinicalText: (text) => {
    dispatch({ type: EDIT_CLINICAL_TEXT, payload: { success: true, text } });
  },

  addReference: (textReference) => {
    dispatch({ type: ADD_REFERENCE, payload: { success: true, textReference } });
  },

  editReference: (textReference) => {
    dispatch({ type: EDIT_REFERENCE, payload: { success: true, textReference } });
  },

  deleteReference: (idReference) => {
    dispatch({ type: DELETE_REFERENCE, payload: { success: true, idReference } });
  },

  addComment: (commentObj) => {
    dispatch({ type: ADD_COMMENT, payload: { success: true, commentObj } });
  },

  editComment: (objEditComment) => {
    dispatch({ type: EDIT_COMMENT, payload: { success: true, objEditComment } });
  },

  deleteComment: (indexToDelete) => {
    dispatch({ type: DELETE_COMMENT, payload: { success: true, indexToDelete } });
  },


  // ------------------CLINICAL CASE QUESTIONS-------------//

  addQuestion: () => {
    let newArrayQuestions = _.cloneDeep(questionTemplate)
    dispatch({ type: ADD_QUESTION, payload: { success: true, newArrayQuestions } });
  },

  deleteQuestion: (paginationState) => {
    dispatch({ type: DELETE_QUESTION, payload: { success: true, paginationState } });
  },

  languageQuestion: (objStatusQuestion) => {
    dispatch({ type: STATUS_QUESTION_LANGUAGE, payload: { success: true, objStatusQuestion } });
  },

  editQuestion: (value, paginationState) => {
    const objQuestion = {
      value,
      paginationState
    }
    dispatch({ type: EDIT_QUESTION, payload: { success: true, objQuestion } });
  },

  editJustification: (value, paginationState) => {
    const objJustification = {
      value,
      paginationState
    }
    dispatch({ type: EDIT_QUESTION_JUSTIFICATION, payload: { success: true, objJustification } });
  },

  // ------------------CLINICAL CASE ANSWERS-------------//

  addAnswer: (paginationState) => {
    const obj = {
      paginationState,
      answerTemplate
    }
    dispatch({ type: ADD_ANSWER, payload: { success: true, obj } });
  },

  editAnswer: (objAnswer) => {
    dispatch({ type: EDIT_ANSWER, payload: { success: true, objAnswer } });
  },

  deleteAnswer: (objAnswer) => {
    dispatch({ type: DELETE_ANSWER, payload: { success: true, objAnswer } });
  },

  correctAnswer: (objAnswer) => {
    dispatch({ type: CORRECT_ANSWER, payload: { success: true, objAnswer } });
  },

  // ------------------CLINICAL CASE IMAGES-------------//

  addImage: async (file, typeImage, tempIndex, tempIdAnswer) => {

    let body = {
      filename: file?.name
    }

    return fetchAsync(uploadImg, JSON.stringify(body), "POST")
      .then((data) => {
        console.log("data_IMG_POST")
        console.log(data)
        console.log("data_IMG_POST")
        if (data.success) {
          return uploadData3(data.url, file, "PUT")
            .then((result) => {
              dispatch({ type: ADD_IMAGES, payload: { success: true, image: data.image, typeImage, tempIndex, tempIdAnswer } });
              return data
            }).catch(error => {
              console.log(error)
              return error
            })
        } else {
          return data
        }
      }).catch((reason) => {
        console.log(reason)
        return reason
      });
  },

  deleteImage: (objImage) => {
    dispatch({ type: DELETE_IMAGES, payload: { success: true, objImage } });
  },
});



// addImage: async ({ file, onError,
  //   onProgress, onSuccess,
  //   typeImage, tempIndex, tempIdAnswer
  // }) => {

  //   let body = {
  //     filename: file.name
  //   }

  //   console.log("image_props_vee_actions")
  //   console.log(body)
  //   console.log(file)
  //   console.log(onError)
  //   console.log(onProgress)
  //   console.log(typeImage)
  //   console.log(tempIndex)
  //   console.log(tempIdAnswer)
  //   console.log("image_props_vee_actions")

  //   return fetchAsync(uploadImg, JSON.stringify(body), "POST")
  //     .then((data) => {
  //       console.log("data_IMG_POST")
  //       console.log(data)
  //       console.log("data_IMG_POST")
  //       if (data.success) {
  //         return uploadData3(data.url, file, "PUT", (percentage, index) => onProgress(percentage, file), 1)
  //           .then((result) => {
  //             console.log("RESULT_uploadData3")
  //             console.log(result)
  //             console.log("RESULT_uploadData3")
  //             dispatch({ type: ADD_IMAGES, payload: { success: true, image: data.image, typeImage, tempIndex, tempIdAnswer } });
  //             onSuccess(result, file)
  //             return data.image
  //           }).catch(error => {
  //             onError(error, file)
  //           })
  //       }
  //     }).catch((reason) => {
  //       onError(reason, file)
  //     });
  // },